<div class="dialog-header">
    <h2 class="dialog-title">Employee Enrollment</h2>
    <button mat-icon-button class="close-button" mat-dialog-close (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content">
    <div *ngIf="!isStepperVisible">
        <div *ngIf="data?.type !== 'update'">
            <form [formGroup]="firstFormGroup" class="form-section">
                <ng-template matStepLabel> Employment </ng-template>
                <div class="aadhaar-wrapper">
                    <mat-form-field appearance="outline">
                        <mat-label> Aadhaar Number </mat-label>
                        <input matInput formControlName="aadhaar_number" maxlength="12" inputmode="numeric"
                            (input)="onAadhaarChange()" />
                        <mat-error *ngIf="firstFormGroup.get('aadhaar_number')?.hasError('required')">
                            Aadhaar number is required
                        </mat-error>
                        <mat-error *ngIf="firstFormGroup.get('aadhaar_number')?.hasError('pattern')">
                            Only numbers allowed & must be 12 digits
                        </mat-error>
                        <mat-error *ngIf="firstFormGroup.get('aadhaar_number')?.hasError('required')">
                            <mat-icon> info </mat-icon>
                            <span>
                                Aadhaar number is required & must be 12 digits
                            </span>
                        </mat-error>
                    </mat-form-field>
                    <span *ngIf="isNewAadhar" class="new-aadhaar-message">
                        This aadhaar number is new to our company
                    </span>
                </div>
                <mat-form-field appearance="outline" *ngIf="isExitEmployee || isValidated">
                    <mat-label> Aadhaar Name </mat-label>
                    <input matInput formControlName="aadhaar_name" />
                </mat-form-field>
                <mat-form-field appearance="outline" class="dob" *ngIf="isExitEmployee || isValidated">
                    <mat-label>Date of Birth</mat-label>

                    <input matInput type="text" formControlName="dob" placeholder="DD-MM-YYYY" maxlength="10"
                        inputmode="numeric" autocomplete="off" (input)="onDobInput($event)" />
                    <div matSuffix class="dob-picker-suffix">
                        <button mat-icon-button type="button" (click)="openDobCalendar(firstDobPicker)"
                            title="Choose from calendar" class="dob-calendar-btn">
                            <mat-icon>calendar_today</mat-icon>
                        </button>
                        <input #firstDobPicker type="date" class="hidden-date-picker" [max]="today"
                            (change)="onDobCalendarChange($event)" tabindex="-1" />
                    </div>
                    <mat-hint>Format: DD-MM-YYYY</mat-hint>

                    <mat-error *ngIf="firstFormGroup.get('dob')?.hasError('required')">
                        Date of Birth is required
                    </mat-error>

                    <mat-error *ngIf="firstFormGroup.get('dob')?.hasError('pattern')">
                        Enter Date of Birth in DD-MM-YYYY format
                    </mat-error>
                </mat-form-field>
                <div class="employment-actions">
                    <button type="button" mat-raised-button color="primary" class="validate-button"
                        (click)="onSubmitEmployment()" [disabled]="isValidating"
                        *ngIf="isValidate && !isBlacklistedEmployee">
                        <span *ngIf="!isValidating">
                            Validate
                        </span>
                        <span *ngIf="isValidating">
                            Validating...
                        </span>
                    </button>
                    <button type="button" mat-raised-button color="primary" class="proceed-button"
                        (click)="proceedToEnrollment()" *ngIf="isProceed && isValidated && !isBlacklistedEmployee">
                        Proceed for Enrollment
                    </button>
                </div>
                <div class="blacklisted-employee-section" *ngIf="isBlacklistedEmployee">
                    <div class="blacklisted-message">
                        <mat-icon> block </mat-icon>
                        <div>
                            <strong>
                                Black Listed Employee
                            </strong>
                            <span>
                                Black List Employee Not Allowed
                                For Re-enrolment
                            </span>
                        </div>
                    </div>
                </div>
                <div class="exit-employee-section" *ngIf="isExitEmployee && exitEmployeeInfo && !isBlacklistedEmployee">
                    <div class="exit-info-message">
                        <mat-icon> info </mat-icon>
                        <div>
                            <strong>
                                Exited Employee Found
                            </strong>
                            <span>
                                This Aadhaar number belongs to an
                                exited employee. Please review the
                                information below before proceeding
                                with the new enrollment.
                            </span>
                        </div>
                    </div>
                    <div class="exit-section-title">
                        <h3> Exited Employee Information </h3>
                    </div>
                    <div class="exit-table-wrapper">
                        <table class="exit-employee-table">
                            <thead>
                                <tr>
                                    <th> Aadhaar Number </th>
                                    <th> Aadhaar Name </th>
                                    <th> Date of Birth </th>
                                    <th> PAPL ID </th>
                                    <th> Branch </th>
                                    <th> Location </th>
                                    <th> Profit / Cost Center </th>
                                    <th> Category </th>
                                    <th> Designation </th>
                                    <th> PAPL Designation </th>
                                    <th> Exit Date </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{ exitEmployeeInfo?.aadhaar_number || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.aadhaar_name || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.dob || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.papl_id || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.branch?.branch_name || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.location?.location_name || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.pcc?.pcc_name || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.category?.category_name || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.designation?.designation_name || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.paplDesignation?.papl_designation_name || '-' }}
                                    </td>
                                    <td>
                                        {{ exitEmployeeInfo?.exit_date || '-' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div *ngIf="isStepperVisible">
        <mat-stepper orientation="vertical" [linear]="isLinear" #stepper>

            <mat-step [stepControl]="secondFormGroup">
                <form [formGroup]="secondFormGroup">
                    <ng-template matStepLabel>Master Details</ng-template>

                    <mat-form-field appearance="outline">
                        <mat-label>{{ isPermanentEmployeeEdit ? 'PAPL ID' : 'Temporary Enrollment ID' }}</mat-label>
                        <input matInput formControlName="temp_emp_id" readonly tabindex="-1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Aadhaar Number</mat-label>
                        <input matInput formControlName="aadhaar_number" [(ngModel)]="enrolAadhar" readonly
                            tabindex="-1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Aadhaar Name</mat-label>
                        <input matInput formControlName="aadhaar_name" [(ngModel)]="enrolName" readonly tabindex="-1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput type="text" formControlName="dob" [value]="secondFormGroup.get('dob')?.value || enrolDob || ''" readonly tabindex="-1" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Select Branch</mat-label>
                        <mat-select formControlName="branch_id" name="branch_id"
                            (selectionChange)="onBranchChange($event.value)">
                            <mat-option *ngFor="let branch of branch_data" [value]="branch.id">
                                {{ branch.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="secondFormGroup.get('branch_id')?.hasError('required')">
                            Branch is required
                        </mat-error>
                    </mat-form-field>

                    <div class="pcc-wrapper">
                        <mat-form-field appearance="outline">
                            <mat-label>Select Profit/Cost Center</mat-label>
                            <mat-select formControlName="profit_cost_id" name="profit_cost_id"
                                (selectionChange)="onProfitCostChange($event.value)">
                                <mat-option *ngFor="let pcc of pcc_data" [value]="pcc.id">
                                    {{ pcc.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('profit_cost_id')?.hasError('required')">
                                Profit/Cost Center is required
                            </mat-error>
                        </mat-form-field>

                        <div *ngIf="manpowerData" class="manpower-display" [ngClass]="{
                                'green-alert': (manpowerData?.manpower_left_pccc) > 0,
                                'red-alert': (manpowerData?.manpower_left_pccc) <= 0
                            }">
                            <div>Max Manpower : {{ manpowerData.total_manpower_pccc }}</div>
                            <div>Manpower Left : {{ manpowerData.manpower_left_pccc }}</div>
                            <div>Current Manpower : {{ manpowerData.current_manpower_pccc }}</div>
                        </div>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Select Department</mat-label>
                        <mat-select formControlName="department_id" name="department_id"
                            (selectionChange)="onDepartmentChange($event.value)" [disabled]="isDisabled">
                            <mat-option *ngFor="let dept of department_data" [value]="dept.id">
                                {{ dept.department_name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="secondFormGroup.get('department_id')?.hasError('required')">
                            Department is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Select Category</mat-label>
                        <mat-select formControlName="category_id" name="category_id"
                            (selectionChange)="onDesignationChange($event.value)" [disabled]="isDisabled">
                            <mat-option *ngFor="let category of category_data" [value]="category.id">
                                {{ category.category_name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="secondFormGroup.get('category_id')?.hasError('required')">
                            Category is required
                        </mat-error>
                    </mat-form-field>

                    <div class="pcc-wrapper">
                        <mat-form-field appearance="outline">
                            <mat-label>Select Designation</mat-label>
                            <mat-select formControlName="designation_id" name="designation_id"
                                (selectionChange)="onChange($event.value)" [disabled]="isDisabled || !secondFormGroup.get('category_id')?.value">
                                <mat-option *ngFor="let designation of designation_data" [value]="designation.id">
                                    {{ designation.designation }}
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="!secondFormGroup.get('category_id')?.value">Select Category first</mat-hint>
                            <mat-error *ngIf="secondFormGroup.get('designation_id')?.hasError('required')">
                                Designation is required
                            </mat-error>
                        </mat-form-field>
                        <div *ngIf="selectedDesignationManpower" class="designation-box" [ngClass]="{
                                'green-alert': (selectedDesignationManpower?.left > 0),
                                'red-alert': (selectedDesignationManpower?.left <= 0)
                                }">
                            <span class="row-item">Max Manpower : <strong>{{ selectedDesignationManpower.max
                                    }}</strong></span>
                            <span class="row-item">Current Manpower : <strong>{{ selectedDesignationManpower.current
                                    }}</strong></span>
                            <span class="row-item">Manpower Left : <strong>{{ selectedDesignationManpower.left
                                    }}</strong></span>
                        </div>
                    </div>

                    <div class="pcc-wrapper">
                        <mat-form-field appearance="outline">
                            <mat-label>Select Grade</mat-label>
                            <mat-select formControlName="grade_id" name="grade_id"
                                (selectionChange)="onGradeChange($event.value)" [disabled]="isDisabled || !secondFormGroup.get('designation_id')?.value">
                                <mat-option *ngFor="let grade of filtered_grade_data" [value]="grade.grade_id || grade.id">
                                    {{ grade.grade?.grade_name || grade.grade_name }}
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="!secondFormGroup.get('designation_id')?.value">Select Designation first</mat-hint>
                            <mat-error *ngIf="secondFormGroup.get('grade_id')?.hasError('required')">
                                Grade is required
                            </mat-error>
                        </mat-form-field>
                        <div *ngIf="slabDetails" class="slab-box">
                            <span class="row-item">Slab Name : <strong>{{ slabDetails.slab_name }}</strong></span>
                            <span class="row-item">Min Price : <strong>{{ slabDetails.min_price }}</strong></span>
                            <span class="row-item">Max Price : <strong>{{ slabDetails.max_price }}</strong></span>
                        </div>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Select PAPLdesignation</mat-label>
                        <mat-select [(ngModel)]="PAPLdesignation_id" name="PAPLdesignation_id" [disabled]="isDisabled">
                            <mat-option *ngFor="let PAPLdesignation of PAPLdesignation_data"
                                [value]="PAPLdesignation.id">
                                {{ PAPLdesignation.PAPLdesignation }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Experience (in years)</mat-label>
                        <input matInput type="text" formControlName="experience" maxlength="2" pattern="[0-9]{1,2}"
                            (keypress)=" ($event.charCode >= 48 && $event.charCode <= 57)
                                            ? true
                                            : $event.preventDefault()
                                        " />
                        <mat-error *ngIf="secondFormGroup.get('experience')?.hasError('pattern')">
                            Enter a valid experience (1–2 digits)
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Father / Husband Name</mat-label>
                        <input matInput formControlName="father_husband_name" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Relation with Employee</mat-label>
                        <mat-select formControlName="relation_with_employee">
                            <mat-option value="Father">Father</mat-option>
                            <mat-option value="Husband">Husband</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Gender</mat-label>
                        <mat-select formControlName="gender">
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                            <mat-option value="Transgender">Transgender</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Marital Status</mat-label>
                        <mat-select formControlName="marital_status" required>
                            <mat-option value="">Select Marital Status</mat-option>
                            <mat-option *ngFor="let ms of maritalStatus" [value]="ms">{{ ms }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="secondFormGroup.get('marital_status')?.hasError('required')">
                            Marital status is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Mobile Number (Linked with Aadhaar)</mat-label>
                        <input matInput type="text" formControlName="mobile_with_adhar" maxlength="10"
                            (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                        <mat-error *ngIf="secondFormGroup.get('mobile_with_adhar')?.hasError('required')">
                            Mobile number is required
                        </mat-error>

                        <mat-error *ngIf="secondFormGroup.get('mobile_with_adhar')?.hasError('pattern')">
                            Enter a valid 10-digit mobile number
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>WhatsApp Number</mat-label>
                        <input matInput type="text" formControlName="whatsapp_number" maxlength="10"
                            (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                        <mat-error *ngIf="secondFormGroup.get('whatsapp_number')?.hasError('pattern')">
                            Enter a valid 10-digit mobile number
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Alternative Email</mat-label>
                        <input matInput type="email" formControlName="alternative_email" />
                    </mat-form-field>
                    <div class="form-section">
                        <h3 class="section-title">Present Address</h3>

                        <mat-form-field appearance="outline">
                            <mat-label>Address</mat-label>
                            <textarea matInput formControlName="present_address"></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>State</mat-label>
                            <mat-select formControlName="present_state"
                                (selectionChange)="onPresentStateChange($event.value)">
                                <mat-option *ngFor="let state of state_data" [value]="state.id">
                                    {{ state.state_name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>District</mat-label>
                            <mat-select formControlName="present_district">
                                <mat-option *ngFor="let district of presentDistricts" [value]="district.id">
                                    {{ district.dist_name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Police Station (PS)</mat-label>
                            <input matInput formControlName="present_ps" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Post Office (PO)</mat-label>
                            <input matInput formControlName="present_po" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Village</mat-label>
                            <input matInput formControlName="present_village" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Block</mat-label>
                            <input matInput formControlName="present_block" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Tehsil</mat-label>
                            <input matInput formControlName="present_tehsil" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Gram Panchayat(GP)</mat-label>
                            <input matInput formControlName="present_gp" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Pincode</mat-label>
                            <input matInput type="text" formControlName="present_pincode" maxlength="6"
                                pattern="[0-9]{6}"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                            <mat-error *ngIf="secondFormGroup.get('present_pincode')?.hasError('pattern')">
                                Enter a valid 6-digit pincode
                            </mat-error>
                        </mat-form-field>


                        <mat-form-field appearance="outline">
                            <mat-label>Mobile Number </mat-label>
                            <input matInput type="text" formControlName="present_mobile_number" maxlength="10"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                            <mat-error *ngIf="secondFormGroup.get('present_mobile_number')?.hasError('pattern')">
                                Enter a valid 10-digit mobile number
                            </mat-error>
                        </mat-form-field>

                    </div>
                    <div class="form-section">
                        <div class="address-checkbox">
                            <mat-checkbox [checked]="sameAsPresentAddress" (change)="sameAsPresent($event)">
                                Same as Present Address
                            </mat-checkbox>
                        </div>
                        <h3 class="section-title">Permanent Address</h3>
                        <mat-form-field appearance="outline">
                            <mat-label>Address</mat-label>
                            <textarea matInput formControlName="permanent_addrs"
                                [readonly]="sameAsPresentAddress"></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>State</mat-label>
                            <mat-select formControlName="permanent_state" [disabled]="sameAsPresentAddress"
                                (selectionChange)="onPermanentStateChange($event.value)">
                                <mat-option *ngFor="let state of state_data" [value]="state.id">
                                    {{ state.state_name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>District</mat-label>
                            <mat-select formControlName="permanent_district" [disabled]="sameAsPresentAddress">
                                <mat-option *ngFor="let district of permanentDistricts" [value]="district.id">
                                    {{ district.dist_name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Police Station (PS)</mat-label>
                            <input matInput formControlName="permanent_ps" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Post Office (PO)</mat-label>
                            <input matInput formControlName="permanent_po" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Village</mat-label>
                            <input matInput formControlName="permanent_village" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Block</mat-label>
                            <input matInput formControlName="permanent_block" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Tehsil</mat-label>
                            <input matInput formControlName="permanent_tehsil" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Gram Panchayat(GP)</mat-label>
                            <input matInput formControlName="permanent_gp" [readonly]="sameAsPresentAddress" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Pincode</mat-label>
                            <input matInput type="text" formControlName="permanent_pincode" maxlength="6"
                                pattern="[0-9]{6}"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()"
                                [readonly]="sameAsPresentAddress" />
                            <mat-error *ngIf="secondFormGroup.get('permanent_pincode')?.hasError('required')">
                                Pincode is required
                            </mat-error>
                            <mat-error *ngIf="secondFormGroup.get('permanent_pincode')?.hasError('pattern')">
                                Enter a valid 6-digit pincode
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Mobile Number</mat-label>
                            <input matInput type="text" formControlName="permanent_mobile_number" maxlength="10"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()"
                                [readonly]="sameAsPresentAddress" />
                            <mat-error *ngIf="secondFormGroup.get('permanent_mobile_number')?.hasError('required')">
                                Mobile number is required
                            </mat-error>
                            <mat-error *ngIf="secondFormGroup.get('permanent_mobile_number')?.hasError('pattern')">
                                Enter a valid 10-digit mobile number
                            </mat-error>
                        </mat-form-field>

                    </div>

                    <div class="form-section">
                        <h3 class="section-title">Employee Details</h3>

                        <mat-form-field appearance="outline">
                            <mat-label>Blood Group</mat-label>
                            <mat-select formControlName="blood_group" required>
                                <mat-option value="">Select Blood Group</mat-option>
                                <mat-option *ngFor="let group of bloodGroups" [value]="group">{{ group }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('blood_group')?.hasError('required')">
                                Blood group is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Identification Mark</mat-label>
                            <input matInput formControlName="ID_mark_employee" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Nationality</mat-label>
                            <mat-select formControlName="nationality" required>
                                <mat-option value="">Select Nationality</mat-option>
                                <mat-option *ngFor="let n of nationality" [value]="n">{{ n }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('nationality')?.hasError('required')">
                                Nationality is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Religion</mat-label>
                            <mat-select formControlName="religion" required>
                                <mat-option value="">Select Religion</mat-option>
                                <mat-option *ngFor="let r of religion" [value]="r">{{ r }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('religion')?.hasError('required')">
                                Religion is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Caste</mat-label>
                            <mat-select formControlName="caste" required>
                                <mat-option value="">Select Caste</mat-option>
                                <mat-option *ngFor="let c of caste" [value]="c">{{ c }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="secondFormGroup.get('caste')?.hasError('required')">
                                Caste is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Health Insurance No</mat-label>
                            <input matInput formControlName="health_insurance_no" />
                        </mat-form-field>
                    </div>

                    <!-- Master Documents -->
                    <div class="document-group">
                        <h3>Documents</h3>

                        <div class="document-grid">

                            <!-- Experience Certificate -->
                            <div class="file-upload-card">
                                <label>Experience Certificate</label>

                                <div class="file-upload-row">
                                    <input type="file" #expInput accept=".pdf,application/pdf" style="display: none" (change)="onDocumentSelected(
                                        $event,
                                        'browse_experience',
                                        secondFormGroup
                                        )">

                                    <button type="button" class="btn-choose-file" (click)="expInput.click()">
                                        <mat-icon>upload_file</mat-icon>
                                        {{ selectedMasterDocuments['browse_experience'] || secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value ? 'Change File' : 'Choose File' }}
                                    </button>

                                    <!-- Display Chosen File Name -->
                                    <span *ngIf="selectedMasterDocuments['browse_experience']" class="file-name-display" [title]="selectedMasterDocuments['browse_experience']?.name">
                                        <mat-icon>attach_file</mat-icon> {{ selectedMasterDocuments['browse_experience']?.name }}
                                    </span>
                                    <span *ngIf="!selectedMasterDocuments['browse_experience'] && (secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value)"
                                          class="file-name-display"
                                          [title]="getFileName(secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value)">
                                        <mat-icon>attach_file</mat-icon> {{ getFileName(secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value) }}
                                    </span>
                                    <span *ngIf="!selectedMasterDocuments['browse_experience'] && !(secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value)" class="no-file-text">
                                        No file chosen
                                    </span>

                                    <!-- View Existing or Selected Certificate -->
                                    <div *ngIf="selectedMasterDocuments['browse_experience'] || secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value" class="doc-preview-wrapper">
                                        <button type="button" 
                                                class="btn-view-doc" 
                                                (click)="openDocumentPreview(selectedMasterDocuments['browse_experience'], secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value, 'experience')">
                                            <mat-icon>{{ isPdfFile(selectedMasterDocuments['browse_experience'] || secondFormGroup.get('browse_experience')?.value || secondFormGroup.get('browse_photo')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View Certificate
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Passport Photo -->
                            <div class="file-upload-card">
                                <label>Passport Photo</label>

                                <div class="file-upload-row">
                                    <input type="file" #passportInput style="display: none"  accept=".jpg,.jpeg,.png,image/jpeg,image/png" (change)="onDocumentSelected(
                                        $event,
                                        'browse_passport_photo',
                                        secondFormGroup
                                        )">

                                    <button type="button" class="btn-choose-file" (click)="passportInput.click()">
                                        <mat-icon>upload_file</mat-icon>
                                        {{ selectedMasterDocuments['browse_passport_photo'] || secondFormGroup.get('browse_passport_photo')?.value ? 'Change Photo' : 'Choose Photo' }}
                                    </button>

                                    <!-- Display Chosen File Name -->
                                    <span *ngIf="selectedMasterDocuments['browse_passport_photo']" class="file-name-display" [title]="selectedMasterDocuments['browse_passport_photo']?.name">
                                        <mat-icon>image</mat-icon> {{ selectedMasterDocuments['browse_passport_photo']?.name }}
                                    </span>
                                    <span *ngIf="!selectedMasterDocuments['browse_passport_photo'] && secondFormGroup.get('browse_passport_photo')?.value"
                                          class="file-name-display"
                                          [title]="getFileName(secondFormGroup.get('browse_passport_photo')?.value)">
                                        <mat-icon>image</mat-icon> {{ getFileName(secondFormGroup.get('browse_passport_photo')?.value) }}
                                    </span>
                                    <span *ngIf="!selectedMasterDocuments['browse_passport_photo'] && !secondFormGroup.get('browse_passport_photo')?.value" class="no-file-text">
                                        No file chosen
                                    </span>

                                    <!-- View Existing or Selected Passport Photo -->
                                    <div *ngIf="selectedMasterDocuments['browse_passport_photo'] || secondFormGroup.get('browse_passport_photo')?.value" class="doc-preview-wrapper">
                                        <div class="passport-preview-box">
                                            <img [src]="localFilePreviews['browse_passport_photo'] || getDocUrl(secondFormGroup.get('browse_passport_photo')?.value, 'passport')" 
                                                 alt="Passport Photo" 
                                                 class="passport-preview-img" 
                                                 (error)="$any($event.target).style.display='none'" />
                                            <button type="button" 
                                                    class="btn-view-doc" 
                                                    (click)="openDocumentPreview(selectedMasterDocuments['browse_passport_photo'], secondFormGroup.get('browse_passport_photo')?.value, 'passport')">
                                                <mat-icon>open_in_new</mat-icon> View Photo
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Aadhaar -->
                            <div class="file-upload-card">
                                <label>Aadhaar</label>

                                <div class="file-upload-row">
                                    <input type="file" #aadhaarInput style="display: none" accept=".pdf,application/pdf" (change)="onDocumentSelected(
                                        $event,
                                        'browse_aadhaar',
                                        secondFormGroup
                                        )">

                                    <button type="button" class="btn-choose-file" (click)="aadhaarInput.click()">
                                        <mat-icon>upload_file</mat-icon>
                                        {{ selectedMasterDocuments['browse_aadhaar'] || secondFormGroup.get('browse_aadhaar')?.value ? 'Change File' : 'Choose File' }}
                                    </button>

                                    <!-- Display Chosen File Name -->
                                    <span *ngIf="selectedMasterDocuments['browse_aadhaar']" class="file-name-display" [title]="selectedMasterDocuments['browse_aadhaar']?.name">
                                        <mat-icon>attach_file</mat-icon> {{ selectedMasterDocuments['browse_aadhaar']?.name }}
                                    </span>
                                    <span *ngIf="!selectedMasterDocuments['browse_aadhaar'] && secondFormGroup.get('browse_aadhaar')?.value"
                                          class="file-name-display"
                                          [title]="getFileName(secondFormGroup.get('browse_aadhaar')?.value)">
                                        <mat-icon>attach_file</mat-icon> {{ getFileName(secondFormGroup.get('browse_aadhaar')?.value) }}
                                    </span>
                                    <span *ngIf="!selectedMasterDocuments['browse_aadhaar'] && !secondFormGroup.get('browse_aadhaar')?.value" class="no-file-text">
                                        No file chosen
                                    </span>

                                    <!-- View Existing or Selected Aadhaar -->
                                    <div *ngIf="selectedMasterDocuments['browse_aadhaar'] || secondFormGroup.get('browse_aadhaar')?.value" class="doc-preview-wrapper">
                                        <div *ngIf="isImageFile(selectedMasterDocuments['browse_aadhaar'] || secondFormGroup.get('browse_aadhaar')?.value)" class="passport-preview-box">
                                            <img [src]="localFilePreviews['browse_aadhaar'] || getDocUrl(secondFormGroup.get('browse_aadhaar')?.value, 'aadhaar')" 
                                                 alt="Aadhaar" 
                                                 class="passport-preview-img" 
                                                 (error)="$any($event.target).style.display='none'" />
                                            <button type="button" 
                                                    class="btn-view-doc" 
                                                    (click)="openDocumentPreview(selectedMasterDocuments['browse_aadhaar'], secondFormGroup.get('browse_aadhaar')?.value, 'aadhaar')">
                                                <mat-icon>visibility</mat-icon> View Aadhaar
                                            </button>
                                        </div>
                                        <button *ngIf="!isImageFile(selectedMasterDocuments['browse_aadhaar'] || secondFormGroup.get('browse_aadhaar')?.value)" 
                                                type="button" 
                                                class="btn-view-doc" 
                                                (click)="openDocumentPreview(selectedMasterDocuments['browse_aadhaar'], secondFormGroup.get('browse_aadhaar')?.value, 'aadhaar')">
                                            <mat-icon>{{ isPdfFile(selectedMasterDocuments['browse_aadhaar'] || secondFormGroup.get('browse_aadhaar')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View Aadhaar
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button [disabled]="isDisabled" [ngClass]="{'disabled-class': isDisabled}" mat-raised-button
                            color="primary" (click)="onSubmitMaster()"> Save
                            Master</button>
                    </div>
                </form>
            </mat-step>            <mat-step [stepControl]="thirdFormGroup">

                <form [formGroup]="thirdFormGroup" class="qualification-form">

                    <ng-template matStepLabel>
                        Qualification Details
                    </ng-template>

                    <div formArrayName="qualifications" class="qualifications-container">

                        <div *ngFor="let q of qualifications.controls; let i = index" [formGroupName]="i"
                            class="qualification-row">

                            <!-- University / Board -->
                            <mat-form-field appearance="outline" class="qual-field qual-univ">
                                <mat-label>University / Board</mat-label>
                                <input matInput formControlName="university_board_name">
                            </mat-form-field>

                            <!-- College / Institute -->
                            <mat-form-field appearance="outline" class="qual-field qual-college">
                                <mat-label>College / Institute Name</mat-label>
                                <input matInput formControlName="college_institute_name">
                            </mat-form-field>

                            <!-- Year -->
                            <mat-form-field appearance="outline" class="qual-field qual-year">
                                <mat-label>Year of Passout</mat-label>
                                <mat-select formControlName="year_of_passout">
                                    <mat-option *ngFor="let y of years" [value]="y">
                                        {{ y }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Division / Percentage -->
                            <mat-form-field appearance="outline" class="qual-field qual-div">
                                <mat-label>Division / Percent</mat-label>
                                <input matInput formControlName="division_percent">
                            </mat-form-field>

                            <!-- Qualification -->
                            <mat-form-field appearance="outline" class="qual-field qual-degree">
                                <mat-label>Qualification</mat-label>
                                <mat-select formControlName="qualification">
                                    <mat-option value="">Select Qualification</mat-option>
                                    <mat-option *ngFor="let qualification of qualificationOptions"
                                        [value]="qualification">
                                        {{ qualification }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Qualification Document -->
                            <div class="file-upload-card qualification-doc-card">
                                <label>Qualification Document</label>

                                <div class="file-upload-row">
                                    <input type="file" #qualInput style="display: none" accept=".pdf,application/pdf"
                                        (change)="onQualificationDocumentSelected($event, i)">

                                    <button type="button" class="btn-choose-file" (click)="qualInput.click()">
                                        <mat-icon>upload_file</mat-icon>
                                        {{ selectedQualificationFiles[i] || q.get('qualification_document')?.value || $any(q).existingFileName ? 'Change File' : 'Choose File' }}
                                    </button>

                                    <!-- Selected local file name -->
                                    <span *ngIf="selectedQualificationFiles[i]" class="file-name-display" [title]="selectedQualificationFiles[i]?.name">
                                        <mat-icon>{{ isImageFile(selectedQualificationFiles[i]?.name) ? 'image' : 'attach_file' }}</mat-icon>
                                        {{ selectedQualificationFiles[i]?.name }}
                                    </span>

                                    <!-- Existing Document File Name -->
                                    <span *ngIf="!selectedQualificationFiles[i] && (q.get('qualification_document')?.value || $any(q).existingFileName)"
                                          class="file-name-display"
                                          [title]="getFileName(q.get('qualification_document')?.value || $any(q).existingFileName)">
                                        <mat-icon>{{ isImageFile(q.get('qualification_document')?.value || $any(q).existingFileName) ? 'image' : 'attach_file' }}</mat-icon>
                                        {{ getFileName(q.get('qualification_document')?.value || $any(q).existingFileName) }}
                                    </span>

                                    <span *ngIf="!selectedQualificationFiles[i] && !(q.get('qualification_document')?.value || $any(q).existingFileName)" class="no-file-text">
                                        No file chosen
                                    </span>

                                    <!-- View Existing or Selected Qualification Document -->
                                    <div *ngIf="selectedQualificationFiles[i] || q.get('qualification_document')?.value || $any(q).existingFileName" class="doc-preview-wrapper">
                                        <div *ngIf="isImageFile(selectedQualificationFiles[i] || q.get('qualification_document')?.value || $any(q).existingFileName)" class="passport-preview-box">
                                            <img [src]="selectedQualificationPreviews[i] || getDocUrl(q.get('qualification_document')?.value || $any(q).existingFileName, 'qualification')" 
                                                 alt="Qualification Doc" 
                                                 class="passport-preview-img" 
                                                 (error)="$any($event.target).style.display='none'" />
                                            <button type="button" 
                                                    class="btn-view-doc" 
                                                    (click)="openDocumentPreview(selectedQualificationFiles[i], q.get('qualification_document')?.value || $any(q).existingFileName, 'qualification', selectedQualificationPreviews[i])">
                                                <mat-icon>open_in_new</mat-icon> View Image
                                            </button>
                                        </div>
                                        <button *ngIf="!isImageFile(selectedQualificationFiles[i] || q.get('qualification_document')?.value || $any(q).existingFileName)" 
                                                type="button" 
                                                class="btn-view-doc" 
                                                (click)="openDocumentPreview(selectedQualificationFiles[i], q.get('qualification_document')?.value || $any(q).existingFileName, 'qualification', selectedQualificationPreviews[i])">
                                            <mat-icon>{{ isPdfFile(selectedQualificationFiles[i] || q.get('qualification_document')?.value || $any(q).existingFileName) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View Document
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Delete -->
                            <div class="qual-actions">
                                <button mat-icon-button color="warn" type="button" *ngIf="qualifications.length > 1"
                                    (click)="removeQualification(i)" title="Remove qualification">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                        </div>

                        <!-- Add More -->
                        <div class="mt-2 mb-3">
                            <button mat-raised-button color="primary" type="button" (click)="addQualification()">
                                <mat-icon>add</mat-icon> Add More
                            </button>
                        </div>

                    </div>

                    <!-- Step Controls -->
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>
                            Back
                        </button>

                        <button mat-raised-button color="primary" type="button" (click)="onSubmitQualification()">
                            Save Qualifications
                        </button>
                    </div>

                </form>

            </mat-step>

            <mat-step [stepControl]="fourthFormGroup">
                <form [formGroup]="fourthFormGroup">
                    <ng-template matStepLabel>Bank Details</ng-template>

                    <mat-form-field appearance="outline"><mat-label>Name of Bank</mat-label>
                        <mat-select formControlName="name_bank" required (selectionChange)="onBankChange($event)">
                            <mat-option value="">Select Bank</mat-option>
                            <mat-option *ngFor="let bank of bankNames" [value]="bank">{{ bank }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="fourthFormGroup.get('name_bank')?.hasError('required')">Bank Name is
                            required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="isOtherBankNameVisible"><mat-label>Other Bank Name</mat-label>
                        <input matInput formControlName="other_bank_name" />
                    </mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>Branch Name</mat-label><input matInput
                            formControlName="name_branch" /></mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>IFSC</mat-label><input matInput
                            formControlName="ifsc" /></mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>Name as per Passbook</mat-label><input matInput
                            formControlName="name_passbook" /></mat-form-field>
                    <mat-form-field appearance="outline"><mat-label>Bank Account Number</mat-label><input matInput
                            formControlName="bank_account_number" /></mat-form-field>
                    <!-- Bank Document (placed beside Bank Account Number) -->
                    <div class="file-upload-card bank-upload-card">
                        <label>Passbook / Cancelled Cheque</label>

                        <div class="file-upload-row">
                            <input type="file" #bankInput style="display: none" accept=".pdf,application/pdf" (change)="onDocumentSelected(
                                $event,
                                'pass_book_photo',
                                fourthFormGroup
                            )">

                            <button type="button" class="btn-choose-file" (click)="bankInput.click()">
                                <mat-icon>upload_file</mat-icon>
                                {{ selectedBankDocument || fourthFormGroup.get('pass_book_photo')?.value ? 'Change File' : 'Choose File' }}
                            </button>

                            <!-- Display Chosen File Name -->
                            <span *ngIf="selectedBankDocument" class="file-name-display" [title]="selectedBankDocument.name">
                                <mat-icon>{{ isImageFile(selectedBankDocument.name) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ selectedBankDocument.name }}
                            </span>
                            <span *ngIf="!selectedBankDocument && fourthFormGroup.get('pass_book_photo')?.value"
                                  class="file-name-display"
                                  [title]="getFileName(fourthFormGroup.get('pass_book_photo')?.value)">
                                <mat-icon>{{ isImageFile(fourthFormGroup.get('pass_book_photo')?.value) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ getFileName(fourthFormGroup.get('pass_book_photo')?.value) }}
                            </span>
                            <span *ngIf="!selectedBankDocument && !fourthFormGroup.get('pass_book_photo')?.value" class="no-file-text">
                                No file chosen
                            </span>

                            <!-- View Existing or Selected Passbook -->
                            <div *ngIf="selectedBankDocument || fourthFormGroup.get('pass_book_photo')?.value" class="doc-preview-wrapper">
                                <div *ngIf="isImageFile(selectedBankDocument || fourthFormGroup.get('pass_book_photo')?.value)" class="passport-preview-box">
                                    <img [src]="localFilePreviews['pass_book_photo'] || getDocUrl(fourthFormGroup.get('pass_book_photo')?.value, 'passbook')" 
                                         alt="Passbook" 
                                         class="passport-preview-img" 
                                         (error)="$any($event.target).style.display='none'" />
                                    <button type="button" 
                                            class="btn-view-doc" 
                                            (click)="openDocumentPreview(selectedBankDocument, fourthFormGroup.get('pass_book_photo')?.value, 'passbook')">
                                        <mat-icon>open_in_new</mat-icon> View Passbook
                                    </button>
                                </div>
                                <button *ngIf="!isImageFile(selectedBankDocument || fourthFormGroup.get('pass_book_photo')?.value)" 
                                        type="button" 
                                        class="btn-view-doc" 
                                        (click)="openDocumentPreview(selectedBankDocument, fourthFormGroup.get('pass_book_photo')?.value, 'passbook')">
                                    <mat-icon>{{ isPdfFile(selectedBankDocument || fourthFormGroup.get('pass_book_photo')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View Passbook
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" (click)="onSubmitBank()"> Save
                            Bankdetails</button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="fiveFormGroup">
                <form [formGroup]="fiveFormGroup">
                    <ng-template matStepLabel>Nominee Details</ng-template>

                    <mat-form-field appearance="outline"><mat-label>Nominee Name</mat-label><input matInput
                            formControlName="nominee_name" /></mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Relationship</mat-label>
                        <mat-select formControlName="nominee_relation">
                            <mat-option value="">Select Relationship</mat-option>
                            <mat-option *ngFor="let relation of bloodRelations" [value]="relation"> {{ relation }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline"><mat-label>Date of Birth</mat-label>
                        <input matInput type="date" (keydown)="$event.preventDefault()"
                            (paste)="$event.preventDefault()" formControlName="nominee_dob" [max]="today" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Nominee Aadhaar Number</mat-label>
                        <input matInput formControlName="nominee_aadhaar_number" maxlength="12"
                            (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()"
                            inputmode="numeric" placeholder="Enter 12-digit Aadhaar" />
                        <mat-error *ngIf="fiveFormGroup.get('nominee_aadhaar_number')?.hasError('pattern')">
                            Aadhaar Number must be exactly 12 digits
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <input matInput formControlName="nominee_address" />
                    </mat-form-field>

                    <!-- Nominee Document (placed beside Address) -->
                    <div class="file-upload-card nominee-upload-card">
                        <label>Nominee Aadhaar</label>

                        <div class="file-upload-row">
                            <input type="file" #nomineeInput style="display: none" accept=".pdf,application/pdf" (change)="onDocumentSelected(
                                $event,
                                'nominee_aadhaar_photo',
                                fiveFormGroup
                            )">

                            <button type="button" class="btn-choose-file" (click)="nomineeInput.click()">
                                <mat-icon>upload_file</mat-icon>
                                {{ selectedNomineeDocument || fiveFormGroup.get('nominee_aadhaar_photo')?.value ? 'Change File' : 'Choose File' }}
                            </button>

                            <!-- Display Chosen File Name -->
                            <span *ngIf="selectedNomineeDocument" class="file-name-display" [title]="selectedNomineeDocument.name">
                                <mat-icon>{{ isImageFile(selectedNomineeDocument.name) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ selectedNomineeDocument.name }}
                            </span>
                            <span *ngIf="!selectedNomineeDocument && fiveFormGroup.get('nominee_aadhaar_photo')?.value"
                                  class="file-name-display"
                                  [title]="getFileName(fiveFormGroup.get('nominee_aadhaar_photo')?.value)">
                                <mat-icon>{{ isImageFile(fiveFormGroup.get('nominee_aadhaar_photo')?.value) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ getFileName(fiveFormGroup.get('nominee_aadhaar_photo')?.value) }}
                            </span>
                            <span *ngIf="!selectedNomineeDocument && !fiveFormGroup.get('nominee_aadhaar_photo')?.value" class="no-file-text">
                                No file chosen
                            </span>

                            <!-- View Existing or Selected Nominee Aadhaar -->
                            <div *ngIf="selectedNomineeDocument || fiveFormGroup.get('nominee_aadhaar_photo')?.value" class="doc-preview-wrapper">
                                <div *ngIf="isImageFile(selectedNomineeDocument || fiveFormGroup.get('nominee_aadhaar_photo')?.value)" class="passport-preview-box">
                                    <img [src]="localFilePreviews['nominee_aadhaar_photo'] || getDocUrl(fiveFormGroup.get('nominee_aadhaar_photo')?.value, 'aadhaar')" 
                                         alt="Nominee Aadhaar" 
                                         class="passport-preview-img" 
                                         (error)="$any($event.target).style.display='none'" />
                                    <button type="button" 
                                            class="btn-view-doc" 
                                            (click)="openDocumentPreview(selectedNomineeDocument, fiveFormGroup.get('nominee_aadhaar_photo')?.value, 'aadhaar')">
                                        <mat-icon>open_in_new</mat-icon> View Aadhaar
                                    </button>
                                </div>
                                <button *ngIf="!isImageFile(selectedNomineeDocument || fiveFormGroup.get('nominee_aadhaar_photo')?.value)" 
                                        type="button" 
                                        class="btn-view-doc" 
                                        (click)="openDocumentPreview(selectedNomineeDocument, fiveFormGroup.get('nominee_aadhaar_photo')?.value, 'aadhaar')">
                                    <mat-icon>{{ isPdfFile(selectedNomineeDocument || fiveFormGroup.get('nominee_aadhaar_photo')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View Aadhaar
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" (click)="onSubmitNominee()"> Save
                            Nominee Details</button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="sixFormGroup">
                <form [formGroup]="sixFormGroup" class="family-form">
                    <ng-template matStepLabel>Family Details</ng-template>

                    <div formArrayName="families" class="family-container">
                        <div *ngFor="let f of families.controls; let i = index" [formGroupName]="i"
                            class="family-row">

                            <!-- Family Member Name -->
                            <mat-form-field appearance="outline" class="family-field">
                                <mat-label>Family Member Name</mat-label>
                                <input matInput formControlName="family_member" />
                            </mat-form-field>

                            <!-- Date of Birth -->
                            <mat-form-field appearance="outline" class="family-field">
                                <mat-label>Date of Birth</mat-label>
                                <input matInput type="date" formControlName="family_member_dob" [max]="today"
                                    (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                            </mat-form-field>

                            <!-- Relationship -->
                            <mat-form-field appearance="outline" class="family-field">
                                <mat-label>Relationship</mat-label>
                                <mat-select formControlName="family_member_relation">
                                    <mat-option value="">Select Relationship</mat-option>
                                    <mat-option value="SPOUSE">SPOUSE</mat-option>
                                    <mat-option value="MOTHER">MOTHER</mat-option>
                                    <mat-option value="FATHER">FATHER</mat-option>
                                    <mat-option value="BROTHER">BROTHER</mat-option>
                                    <mat-option value="SISTER">SISTER</mat-option>
                                    <mat-option value="UNMARRIED DAUGHTER">UNMARRIED DAUGHTER</mat-option>
                                    <mat-option value="SON">SON</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Residence -->
                            <mat-form-field appearance="outline" class="family-field">
                                <mat-label>Residence</mat-label>
                                <input matInput formControlName="family_member_residence" />
                            </mat-form-field>

                            <!-- Family Member Aadhaar -->
                            <div class="file-upload-card family-doc-card">
                                <label>Family Member Aadhaar</label>

                                <div class="file-upload-row">
                                    <input type="file" #famInput style="display: none" accept=".pdf,application/pdf"
                                        (change)="onFamilyDocumentSelected($event, i)">

                                    <button type="button" class="btn-choose-file" (click)="famInput.click()">
                                        <mat-icon>upload_file</mat-icon>
                                        {{ selectedFamilyFiles[i] || f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName ? 'Change File' : 'Choose File' }}
                                    </button>

                                    <!-- Selected local file name -->
                                    <span *ngIf="selectedFamilyFiles[i]" class="file-name-display" [title]="selectedFamilyFiles[i]?.name">
                                        <mat-icon>{{ isImageFile(selectedFamilyFiles[i]?.name) ? 'image' : 'attach_file' }}</mat-icon>
                                        {{ selectedFamilyFiles[i]?.name }}
                                    </span>

                                    <!-- Existing Document File Name -->
                                    <span *ngIf="!selectedFamilyFiles[i] && (f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName)"
                                          class="file-name-display"
                                          [title]="getFileName(f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName)">
                                        <mat-icon>{{ isImageFile(f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName) ? 'image' : 'attach_file' }}</mat-icon>
                                        {{ getFileName(f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName) }}
                                    </span>

                                    <span *ngIf="!selectedFamilyFiles[i] && !(f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName)" class="no-file-text">
                                        No file chosen
                                    </span>

                                    <!-- View Existing or Selected Family Document -->
                                    <div *ngIf="selectedFamilyFiles[i] || f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName" class="doc-preview-wrapper">
                                        <div *ngIf="isImageFile(selectedFamilyFiles[i] || f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName)" class="passport-preview-box">
                                            <img [src]="selectedFamilyPreviews[i] || getDocUrl(f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName, 'family')" 
                                                 alt="Family Aadhaar" 
                                                 class="passport-preview-img" 
                                                 (error)="$any($event.target).style.display='none'" />
                                            <button type="button" 
                                                    class="btn-view-doc" 
                                                    (click)="openDocumentPreview(selectedFamilyFiles[i], f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName, 'family', selectedFamilyPreviews[i])">
                                                <mat-icon>open_in_new</mat-icon> View
                                            </button>
                                        </div>
                                        <button *ngIf="!isImageFile(selectedFamilyFiles[i] || f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName)" 
                                                type="button" 
                                                class="btn-view-doc" 
                                                (click)="openDocumentPreview(selectedFamilyFiles[i], f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName, 'family', selectedFamilyPreviews[i])">
                                            <mat-icon>{{ isPdfFile(selectedFamilyFiles[i] || f.get('family_nominee_aadhaar_photo')?.value || $any(f).existingFileName) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Delete -->
                            <div class="family-actions">
                                <button mat-icon-button color="warn" type="button" *ngIf="families.length > 1"
                                    (click)="removeFamily(i)" title="Remove Family Member">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                        </div>

                        <!-- Add More Button -->
                        <div class="mt-2 mb-3">
                            <button mat-raised-button color="primary" type="button" (click)="addFamily()">
                                <mat-icon>add</mat-icon> Add Family Member
                            </button>
                        </div>
                    </div>

                    <!-- Step Controls -->
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" type="button" (click)="onSubmitFamily()">
                            Save Family Details
                        </button>
                    </div>
                </form>
            </mat-step>

            <mat-step [stepControl]="sevenFormGroup">
                <form [formGroup]="sevenFormGroup" class="epf-esic-form">
                    <ng-template matStepLabel>EPF & ESIC Details</ng-template>

                    <!-- ================= ESIC DETAILS ================= -->
                    <h3 class="section-title">ESIC Details</h3>

                    <mat-form-field appearance="outline">
                        <mat-label>ESIC Code</mat-label>
                        <input matInput formControlName="esic_code" [readonly]="isEsicCodeReadonly" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>ESIC IP Number</mat-label>
                        <input matInput formControlName="esic_ip_number" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>WCA / GPA</mat-label>
                        <mat-select formControlName="wca_gpa" (selectionChange)="onWcaGpaChange($event)">
                            <mat-option value="">Select WCA / GPA</mat-option>
                            <mat-option value="WCA">WCA</mat-option>
                            <mat-option value="GPA">GPA</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>WCA/GPA Expire Date</mat-label>
                        <input matInput type="date" formControlName="wca_gpa_expire_date" [max]="today"
                            (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>ESIC Date</mat-label>
                        <input matInput type="date" formControlName="esic_date" [max]="today"
                            (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                    </mat-form-field>

                    <!-- ESIC Type Radio -->
                    <div class="radio-field-container">
                        <span class="radio-group-label">ESIC Type</span>
                        <mat-radio-group formControlName="esic_type" color="primary" class="custom-radio-group"
                            (change)="onEsicTypeChange($event)">
                            <mat-radio-button value="1">New</mat-radio-button>
                            <mat-radio-button value="0">Existing</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <!-- ESIC Sheet Upload -->
                    <div class="file-upload-card epf-upload-card esic-upload-card">
                        <label>ESIC Sheet</label>

                        <div class="file-upload-row">
                            <input type="file" #esicInput style="display: none" accept=".pdf,application/pdf" (change)="onDocumentSelected(
                                $event,
                                'esic_sheet',
                                sevenFormGroup
                            )">

                            <button type="button" class="btn-choose-file" (click)="esicInput.click()">
                                <mat-icon>upload_file</mat-icon>
                                {{ selectedEpfEsicDocuments['esic_sheet'] || sevenFormGroup.get('esic_sheet')?.value ? 'Change File' : 'Choose File' }}
                            </button>

                            <!-- Display Chosen File Name -->
                            <span *ngIf="selectedEpfEsicDocuments['esic_sheet']" class="file-name-display" [title]="selectedEpfEsicDocuments['esic_sheet']?.name">
                                <mat-icon>{{ isImageFile(selectedEpfEsicDocuments['esic_sheet']?.name) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ selectedEpfEsicDocuments['esic_sheet']?.name }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['esic_sheet'] && sevenFormGroup.get('esic_sheet')?.value"
                                  class="file-name-display"
                                  [title]="getFileName(sevenFormGroup.get('esic_sheet')?.value)">
                                <mat-icon>{{ isImageFile(sevenFormGroup.get('esic_sheet')?.value) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ getFileName(sevenFormGroup.get('esic_sheet')?.value) }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['esic_sheet'] && !sevenFormGroup.get('esic_sheet')?.value" class="no-file-text">
                                No file chosen
                            </span>

                            <!-- View Existing or Selected ESIC Sheet -->
                            <div *ngIf="selectedEpfEsicDocuments['esic_sheet'] || sevenFormGroup.get('esic_sheet')?.value" class="doc-preview-wrapper">
                                <div *ngIf="isImageFile(selectedEpfEsicDocuments['esic_sheet'] || sevenFormGroup.get('esic_sheet')?.value)" class="passport-preview-box">
                                    <img [src]="localFilePreviews['esic_sheet'] || getDocUrl(sevenFormGroup.get('esic_sheet')?.value, 'esic')" 
                                         alt="ESIC Sheet" class="passport-preview-img" (error)="$any($event.target).style.display='none'" />
                                    <button type="button" class="btn-view-doc" (click)="openDocumentPreview(selectedEpfEsicDocuments['esic_sheet'], sevenFormGroup.get('esic_sheet')?.value, 'esic')">
                                        <mat-icon>open_in_new</mat-icon> View Sheet
                                    </button>
                                </div>
                                <button *ngIf="!isImageFile(selectedEpfEsicDocuments['esic_sheet'] || sevenFormGroup.get('esic_sheet')?.value)" 
                                        type="button" class="btn-view-doc" (click)="openDocumentPreview(selectedEpfEsicDocuments['esic_sheet'], sevenFormGroup.get('esic_sheet')?.value, 'esic')">
                                    <mat-icon>{{ isPdfFile(selectedEpfEsicDocuments['esic_sheet'] || sevenFormGroup.get('esic_sheet')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View Sheet
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- ================= PF ACCOUNT ================= -->
                    <h3 class="section-title">PF Account</h3>

                    <mat-form-field appearance="outline">
                        <mat-label>PF Code</mat-label>
                        <input matInput formControlName="pf_code" [readonly]="isPfCodeReadonly" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>UAN</mat-label>
                        <input matInput formControlName="uan" maxlength="12" required />
                    </mat-form-field>
                    <mat-error *ngIf="sevenFormGroup.get('uan')?.hasError('pattern')">
                        UAN must be 12 digits
                    </mat-error>

                    <mat-form-field appearance="outline">
                        <mat-label>PF Account Number</mat-label>
                        <input matInput formControlName="pf_account_number" required />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>EPF Date</mat-label>
                        <input matInput type="date" formControlName="epf_date" [max]="today"
                            (keydown)="$event.preventDefault()" (paste)="$event.preventDefault()" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>EPF Rule</mat-label>
                        <mat-select formControlName="epf_rule">
                            <mat-option value="1">Yes</mat-option>
                            <mat-option value="0">No</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- PF Type Radio -->
                    <div class="radio-field-container">
                        <span class="radio-group-label">PF Type</span>
                        <mat-radio-group formControlName="pf_type" color="primary" class="custom-radio-group">
                            <mat-radio-button value="1">New</mat-radio-button>
                            <mat-radio-button value="0">Existing</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <!-- Form 11 Upload -->
                    <div class="file-upload-card epf-upload-card">
                        <label>Form 11</label>

                        <div class="file-upload-row">
                            <input type="file" #form11Input style="display: none" accept=".pdf,application/pdf" (change)="onDocumentSelected(
                                $event,
                                'form11_sheet',
                                sevenFormGroup
                            )">

                            <button type="button" class="btn-choose-file" (click)="form11Input.click()">
                                <mat-icon>upload_file</mat-icon>
                                {{ selectedEpfEsicDocuments['form11_sheet'] || sevenFormGroup.get('form11_sheet')?.value ? 'Change File' : 'Choose File' }}
                            </button>

                            <!-- Display Chosen File Name -->
                            <span *ngIf="selectedEpfEsicDocuments['form11_sheet']" class="file-name-display" [title]="selectedEpfEsicDocuments['form11_sheet']?.name">
                                <mat-icon>{{ isImageFile(selectedEpfEsicDocuments['form11_sheet']?.name) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ selectedEpfEsicDocuments['form11_sheet']?.name }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['form11_sheet'] && sevenFormGroup.get('form11_sheet')?.value"
                                  class="file-name-display"
                                  [title]="getFileName(sevenFormGroup.get('form11_sheet')?.value)">
                                <mat-icon>{{ isImageFile(sevenFormGroup.get('form11_sheet')?.value) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ getFileName(sevenFormGroup.get('form11_sheet')?.value) }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['form11_sheet'] && !sevenFormGroup.get('form11_sheet')?.value" class="no-file-text">
                                No file chosen
                            </span>

                            <div *ngIf="selectedEpfEsicDocuments['form11_sheet'] || sevenFormGroup.get('form11_sheet')?.value" class="doc-preview-wrapper">
                                <div *ngIf="isImageFile(selectedEpfEsicDocuments['form11_sheet'] || sevenFormGroup.get('form11_sheet')?.value)" class="passport-preview-box">
                                    <img [src]="localFilePreviews['form11_sheet'] || getDocUrl(sevenFormGroup.get('form11_sheet')?.value, 'form11')" 
                                         alt="Form 11" class="passport-preview-img" (error)="$any($event.target).style.display='none'" />
                                    <button type="button" class="btn-view-doc" (click)="openDocumentPreview(selectedEpfEsicDocuments['form11_sheet'], sevenFormGroup.get('form11_sheet')?.value, 'form11')">
                                        <mat-icon>open_in_new</mat-icon> View Form 11
                                    </button>
                                </div>
                                <button *ngIf="!isImageFile(selectedEpfEsicDocuments['form11_sheet'] || sevenFormGroup.get('form11_sheet')?.value)" 
                                        type="button" class="btn-view-doc" (click)="openDocumentPreview(selectedEpfEsicDocuments['form11_sheet'], sevenFormGroup.get('form11_sheet')?.value, 'form11')">
                                    <mat-icon>{{ isPdfFile(selectedEpfEsicDocuments['form11_sheet'] || sevenFormGroup.get('form11_sheet')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View Form 11
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- UAN Sheet Upload -->
                    <div class="file-upload-card epf-upload-card">
                        <label>UAN Sheet</label>

                        <div class="file-upload-row">
                            <input type="file" #uanInput style="display: none" accept=".pdf,application/pdf" (change)="onDocumentSelected(
                                $event,
                                'uan_sheet',
                                sevenFormGroup
                            )">

                            <button type="button" class="btn-choose-file" (click)="uanInput.click()">
                                <mat-icon>upload_file</mat-icon>
                                {{ selectedEpfEsicDocuments['uan_sheet'] || sevenFormGroup.get('uan_sheet')?.value ? 'Change File' : 'Choose File' }}
                            </button>

                            <!-- Display Chosen File Name -->
                            <span *ngIf="selectedEpfEsicDocuments['uan_sheet']" class="file-name-display" [title]="selectedEpfEsicDocuments['uan_sheet']?.name">
                                <mat-icon>{{ isImageFile(selectedEpfEsicDocuments['uan_sheet']?.name) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ selectedEpfEsicDocuments['uan_sheet']?.name }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['uan_sheet'] && sevenFormGroup.get('uan_sheet')?.value"
                                  class="file-name-display"
                                  [title]="getFileName(sevenFormGroup.get('uan_sheet')?.value)">
                                <mat-icon>{{ isImageFile(sevenFormGroup.get('uan_sheet')?.value) ? 'image' : 'attach_file' }}</mat-icon>
                                {{ getFileName(sevenFormGroup.get('uan_sheet')?.value) }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['uan_sheet'] && !sevenFormGroup.get('uan_sheet')?.value" class="no-file-text">
                                No file chosen
                            </span>

                            <div *ngIf="selectedEpfEsicDocuments['uan_sheet'] || sevenFormGroup.get('uan_sheet')?.value" class="doc-preview-wrapper">
                                <div *ngIf="isImageFile(selectedEpfEsicDocuments['uan_sheet'] || sevenFormGroup.get('uan_sheet')?.value)" class="passport-preview-box">
                                    <img [src]="localFilePreviews['uan_sheet'] || getDocUrl(sevenFormGroup.get('uan_sheet')?.value, 'uan')" 
                                         alt="UAN Sheet" class="passport-preview-img" (error)="$any($event.target).style.display='none'" />
                                    <button type="button" class="btn-view-doc" (click)="openDocumentPreview(selectedEpfEsicDocuments['uan_sheet'], sevenFormGroup.get('uan_sheet')?.value, 'uan')">
                                        <mat-icon>open_in_new</mat-icon> View UAN Sheet
                                    </button>
                                </div>
                                <button *ngIf="!isImageFile(selectedEpfEsicDocuments['uan_sheet'] || sevenFormGroup.get('uan_sheet')?.value)" 
                                        type="button" class="btn-view-doc" (click)="openDocumentPreview(selectedEpfEsicDocuments['uan_sheet'], sevenFormGroup.get('uan_sheet')?.value, 'uan')">
                                    <mat-icon>{{ isPdfFile(selectedEpfEsicDocuments['uan_sheet'] || sevenFormGroup.get('uan_sheet')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View UAN Sheet
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- ================= CTC DETAILS ================= -->
                    <div class="ctc-section">
                        <div class="ctc-header-row">
                            <h3 class="section-title">CTC Details</h3>
                        </div>

                        <!-- Live CTC Total & Slab Summary Box -->
                        <div class="ctc-slab-summary-box" [ngClass]="{
                            'valid-slab': isCtcWithinGradeSlab().valid,
                            'invalid-slab': !isCtcWithinGradeSlab().valid
                        }">
                            <div class="summary-left">
                                <span class="summary-label">Total CTC Sum:</span>
                                <span class="summary-value">₹ {{ getTotalCtcAmount() | number:'1.2-2' }}</span>
                            </div>
                            <div class="summary-right" *ngIf="slabDetails">
                                <span class="slab-badge">
                                    Grade Slab: <strong>{{ slabDetails.slab_name }}</strong>
                                    (Min: ₹{{ slabDetails.min_price | number }} - Max: ₹{{ slabDetails.max_price | number }})
                                </span>
                            </div>
                            <div class="slab-warning" *ngIf="!isCtcWithinGradeSlab().valid">
                                <mat-icon>error_outline</mat-icon>
                                <span>{{ isCtcWithinGradeSlab().message }}</span>
                            </div>
                        </div>

                        <div formArrayName="ctc_details" class="ctc-grid">
                            <div *ngFor="let ctc of ctcDetails.controls; let i = index" [formGroupName]="i"
                                class="ctc-field">
                                <mat-form-field appearance="outline">
                                    <mat-label>
                                        {{ ctc.get('attribute_name')?.value }}
                                    </mat-label>
                                    <input matInput type="number" formControlName="amount" min="0" step="any" inputmode="decimal"
                                        (keydown)="preventNegative($event)" (focus)="onCtcFocus(i, $event)"
                                        (blur)="formatCtc(i)" />
                                    <mat-error *ngIf="ctc.get('amount')?.hasError('minBasic')">
                                        {{ ctc.get('attribute_name')?.value }} value must be greater than 1
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <!-- Browse CTC Upload -->
                    <div class="file-upload-card epf-upload-card">
                        <label>Browse CTC</label>

                        <div class="file-upload-row">
                            <input type="file" #ctcFileInput style="display: none" accept=".pdf,application/pdf"
                                (change)="onCtcDocumentSelected($event)">

                            <button type="button" class="btn-choose-file" (click)="ctcFileInput.click()">
                                <mat-icon>upload_file</mat-icon>
                                {{ selectedEpfEsicDocuments['browse_ctc'] || sevenFormGroup.get('browse_ctc')?.value ? 'Change File' : 'Choose File' }}
                            </button>

                            <!-- Display Chosen File Name -->
                            <span *ngIf="selectedEpfEsicDocuments['browse_ctc']" class="file-name-display" [title]="selectedEpfEsicDocuments['browse_ctc']?.name">
                                <mat-icon>attach_file</mat-icon>
                                {{ selectedEpfEsicDocuments['browse_ctc']?.name }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['browse_ctc'] && sevenFormGroup.get('browse_ctc')?.value"
                                  class="file-name-display"
                                  [title]="getFileName(sevenFormGroup.get('browse_ctc')?.value)">
                                <mat-icon>attach_file</mat-icon>
                                {{ getFileName(sevenFormGroup.get('browse_ctc')?.value) }}
                            </span>
                            <span *ngIf="!selectedEpfEsicDocuments['browse_ctc'] && !sevenFormGroup.get('browse_ctc')?.value" class="no-file-text">
                                No file chosen
                            </span>

                            <div *ngIf="selectedEpfEsicDocuments['browse_ctc'] || sevenFormGroup.get('browse_ctc')?.value" class="doc-preview-wrapper">
                                <button type="button" class="btn-view-doc" (click)="openDocumentPreview(selectedEpfEsicDocuments['browse_ctc'], sevenFormGroup.get('browse_ctc')?.value, 'ctc')">
                                    <mat-icon>{{ isPdfFile(selectedEpfEsicDocuments['browse_ctc'] || sevenFormGroup.get('browse_ctc')?.value) ? 'picture_as_pdf' : 'visibility' }}</mat-icon> View CTC Document
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" (click)="onSubmitEpfEsic()"> Save Epfesic</button>
                    </div>
                </form>
            </mat-step>
        </mat-stepper>
    </div>
</div>